<template>
    <el-dialog
            visible
            width="55%"
            custom-class="exchange-add-dialog"
            @close="onCancel">
            <div slot="title">
                <span class="font18">{{ initData.id? $t('COMMON_EDIT') : $t('COMMON_ADD') }}</span>
            </div>
            <div v-if="activeTab === '1'" class="steps">
                <el-steps :space="200" :active="activeStep" align-center>
                    <el-step :title="$t('select_category')" style="flex-basis: 50%;"></el-step>
                    <el-step :title="$t('select_entity_group')" style="flex-basis: 50%;"></el-step>
                </el-steps>
            </div>
            <el-row class="wrap">
                <el-col :span="activeTab === '1' ? 12 : 24" style="height: 100%;padding-right: 10px;">
                    <div class="category-wrap">
                        <div class="__title">
                            <span class="xing">*</span>
                            {{ $t('TABLE_HEAD_Category') }}
                        </div>
                        <div class="__content">
                            <el-radio-group v-model="category" style="display: flex; flex-direction: column;">
                                <el-radio v-for="item in this.allCategory[Number(activeTab)]" :label="item.value" :key="item.realValue" style="line-height: 3;">
                                    {{ $t(item.value) }}
                                </el-radio>
                                <el-radio :label="customCategory" style="line-height: 3;">
                                    <el-input v-model="customCategory" :placeholder="$t('custom_folder_category')" style="width: calc(100% - 20px);" @input="category = customCategory" />
                                </el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </el-col>
                <el-col v-if="activeStep !== 1 && activeTab === '1'" :span="12" style="height: 100%;padding-left: 10px;">
                    <div class="entity-wrap">
                        <div class="__title">
                            <span class="xing">*</span>
                            {{ $t('TABLE_HEAD_EntityList_group') }}
                        </div>
                        <div class="__content">
                            <el-input :placeholder="$t('ENTER_SEARCH_CONTENT')" v-model="filterText" />
                            <div class="tree">
                                <el-tree :default-expand-all="true"
                                        :expand-on-click-node="false"
                                        v-loading="treeLoading"
                                        :data="treeData"
                                        :props="defaultProps"
                                        :check-strictly="true"
                                        :filter-node-method="filterNode"
                                        node-key="id"
                                        show-checkbox
                                        @check="handleCheckChange"
                                        ref="tree">
                                    <div slot-scope="{ node, data }" class="entity-list-tree-node">
                                        <span :title="node.label" @click="handleNodeCheckChange(data)">{{ node.label }}</span>
                                        <span class="extra-area" v-if="data.childEntity.length > 0">
                                            <a v-if="!isSelectAll(data)" @click="clickAll(data, true)">{{ $t('select_all') }}</a>
                                            <a v-else @click="clickAll(data, false)">{{ $t('unselect_all') }}</a>
                                        </span>
                                    </div>
                                </el-tree>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="onCancel"
                           class="cancel-btn">{{$t('comment_reSet')}}</el-button>
                <el-button type="primary"
                           :loading="saveLoading"
                           @click="onConfirm"
                           class="wl-green">{{$t('btn_save')}}</el-button>
          </span>
    </el-dialog>
</template>

<script>
    import API from "@/api";
    import {mapGetters} from "vuex";
    import allCategory from "../exchange/allCategory";
    export default {
        name: "exchange-add",
        props: {
            activeTab: {
                type: String,
                default: '1',
            },
            saveLoading: {
                type: Boolean,
                default: false
            },
            initData: {
                type: Object,
                default: {}
            },
            onCancel: {
                type: Function,
                default: () => {}
            },
            onAdd: {
                type: Function,
                default: () => {}
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getSite: 'getSite',
            }),
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            },
            category(v) {
                if (v) {
                    this.activeStep = 2;
                } else {
                    this.activeStep = 1;
                }
            },
        },
        data(){
            return {
                treeLoading: false,
                treeData: [],
                defaultProps: {
                    children: 'childEntity',
                    label: 'entityName'
                },
                category: null,
                customCategory: '',
                allCategory: allCategory,
                filterText: '',
                activeStep: 1,
            }
        },
        mounted() {
            if(this.activeTab === '2'){
                const _ = this.allCategory[Number(this.activeTab)].find(item => this.$t(item.value) == this.initData.category)
                if (_) {
                    this.category = _.value
                } else {
                    // 自定义
                    this.category = this.initData.category
                    this.customCategory = this.initData.category
                }
            } else {
                this.initTreeDetail()
            }
        },
        methods: {
            filterNode(value, data) {
                if (!value) return true;
                return data.entityName.toLowerCase().indexOf(value.toLowerCase()) !== -1;
            },
            initTreeDetail() {
                this.treeLoading = true
                const params = {
                    siteId: this.getSite.siteId,
                    exchangeType: '0'
                }
                API.common.queryUserEntity(params).then(res => {
                    if (res.code == '1') {
                        this.treeData = [res.data]
                        if(this.initData.id){
                            const _ = this.allCategory[Number(this.activeTab)].find(item => this.$t(item.value) == this.initData.category)
                            if (_) {
                                this.category = _.value
                            } else {
                                // 自定义
                                this.category = this.initData.category
                                this.customCategory = this.initData.category
                            }
                            this.$nextTick(() => {
                                this.setTreeDisabled(this.treeData)
                                this.$refs.tree.setCheckedKeys([this.initData.entityId]);
                            })
                        }
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.treeLoading = false
                })
            },
            setTreeDisabled(treeData){
                treeData.forEach(item => {
                    item.disabled = true
                    if (item.childEntity && item.childEntity.length > 0) {
                        this.setTreeDisabled(item.childEntity)
                    }
                })
            },
            // 节点被点击
            handleNodeCheckChange(node) {
                if(!node.disabled){
                    node.checked = !node.checked
                    this.$refs.tree.setChecked(node.id, node.checked, false)
                }
            },
            handleCheckChange(node, checkInfo){
                node.checked = checkInfo.checkedKeys.indexOf(node.id) !== -1
            },
            clickAll(data, checked) {
                if( !data.disabled ) {
                    this.$refs.tree.setChecked(data.id, checked, false);
                    data.checked = checked
                }
                if (data.childEntity.length > 0) {
                    data.childEntity.forEach(child => this.clickAll(child, checked));
                }
            },
            isSelectAll(data) {
                //判断当前node是否全部选中
                let flag = data.disabled || data.checked
                if (flag && data.childEntity.length > 0) {
                    flag = data.childEntity.every(item => { return item.disabled || item.checked })
                    if(flag) {
                        let flagArr = []
                        for(let i = 0 ; i < data.childEntity.length; i++ ){
                            if(data.childEntity[i].childEntity.length > 0 ){
                                flagArr[i] = data.childEntity[i].childEntity.every(item => { return item.disabled || item.checked })
                            }
                        }
                        flag = flagArr.every(item => item === true)
                    }
                }
                return flag
            },
            querySearch(queryString, cb) {
                const categortList = this.allCategory[Number(this.activeTab)];
                const results = queryString ? categortList.filter((item) => { return item.realValue.toLowerCase().indexOf(queryString.toLowerCase()) === 0}) : JSON.parse(JSON.stringify(categortList));
                // 调用 callback 返回建议列表的数据
                cb(results.map(v => {
                    v.value = this.$t(v.value)
                    return v
                }))

            },
            handleSelect(item) {
                this.category = item.value
            },
            onConfirm() {
                const findCategory = this.allCategory[Number(this.activeTab)].find(v => (v.value) === this.category)
                
                if(this.activeTab === '2'){
                    if(this.category == null || this.category == ''){
                        this.$message.error(this.$t('ENTER_CATEGORY_LIST'))
                        return
                    }
                    let temp = Object.assign({}, this.initData)
                    temp.category = findCategory && findCategory.realValue ? findCategory.realValue : this.category
                    this.onAdd(temp)
                } else {
                    let entityList = this.$refs.tree.getCheckedKeys()
                    if(entityList.length === 0 && this.activeTab != '2'){
                        this.$message.error(this.$t('ENTER_ENTITY'))
                        return
                    } else if(this.category == null || this.category == ''){
                        this.$message.error(this.$t('ENTER_CATEGORY_LIST'))
                        return
                    } else {
                        let temp = Object.assign({}, this.initData)
                        temp.entityIdList = entityList
                        temp.category = findCategory && findCategory.realValue ? findCategory.realValue : this.category
                        this.onAdd(temp)
                    }
                }

            },
        }
    }
</script>

<style scoped>
    .font18{
        font-size: 18px;
    }
    .select-width{
        width: 100%;
    }
    .entity-list-tree-node {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .entity-list-tree-node .extra-area {
        margin-right: 5px;
        color: #409eff;
        align-self: center;
    }
    .entity-list-tree-node .extra-area:hover {
        margin-right: 5px;
        color: #409eff;
    }
    .required-cls{
        color:#fd349c;
        font-size: 14px;
        margin-right: 5px;
    }
    .tree {
        margin-top: 10px;
        height: calc(100% - 42px);
        overflow-y: auto;
    }

    ::v-deep .exchange-add-dialog {
        height: 80vh;
        margin-top: 10vh !important;
    }
    ::v-deep .el-dialog__body {
        height: calc(100% - 90px);
    }
    .steps {
        margin-bottom: 20px;
    }
    .wrap {
        height: calc(100% - 77px);
    }

    .category-wrap {
        border: 1px solid #e9e9e9;
        border-radius: 10px;
        height: 100%;
        overflow: hidden;
    }
    .entity-wrap {
        border: 1px solid #e9e9e9;
        border-radius: 10px;
        height: 100%;
        overflow: hidden;
    }

    .__title {
        height: 40px;
        display: flex;
        align-items: center;
        background-color: #f3f6ff;
        padding-left: 10px;
        font-weight: 600;
        color: #000;
        font-size: 14px;
    }
    .__title span {
        color: #fd349c;
        font-weight: normal;
        margin-right: 3px;
        font-size: 16px;
        position: relative;
        top: 2px;
    }
    .__content {
        height: calc(100% - 40px);
        padding: 10px;
    }
</style>